//vendors
import React from 'react';
import classNames from 'classnames';

//components
import { Gap } from './Gap';

//utils
import { flexFlowStyle, flexChildStyle, justifyStyle, alignStyle } from './flexUtils';

//styles
import layerStyles from './layout.module.scss';

type Props = {
  size?: string,
  width?: string,
  height?: string,
  minWidth?: string,
  minHeight?: string,
  maxWidth?: string,
  maxHeight?: string,
  justify?: 'start' | 'end' | 'center' | 'between' | 'around',
  align?: 'start' | 'end' | 'center' | 'baseline' | 'stretch',
  alignSelf?: string,
  margin?: string,
  padding?: string,
  gap?: string,
  className?: string,
  wrap?: string,
  style?: Object,
  children?: React.ReactNode | Array<React.ReactNode>
} & any;

export const HBox = (
  {
    size = 'none',
    width,
    height,
    minWidth,
    minHeight,
    maxWidth,
    maxHeight,
    justify = 'start',
    align = 'stretch',
    alignSelf,
    margin,
    padding,
    gap,
    className,
    style,
    wrap,
    children,
    ...other
  }: Props) => {
  let styles: any = {
    ...flexFlowStyle('row nowrap'),
    ...flexChildStyle(size),
    ...justifyStyle(justify),
    ...alignStyle('alignItems', align),
  };

  alignSelf && (styles = { ...styles, ...alignStyle('alignSelf', alignSelf) });
  style && (styles = { ...styles, ...style });
  wrap && (styles.flexWrap = wrap);
  width && (styles.width = width);
  height && (styles.height = height);
  minWidth && (styles.minWidth = minWidth);
  minHeight && (styles.minHeight = minHeight);
  maxWidth && (styles.maxWidth = maxWidth);
  maxHeight && (styles.maxHeight = maxHeight);
  margin && (styles.margin = margin);
  padding && (styles.padding = padding);

  const classes = classNames(layerStyles.displayFlex, className);
  if (gap && Array.isArray(children)) {
    let childrenWithGaps: any[] = [];
    let key = 1;
    children.forEach(function(child) {
      childrenWithGaps.push(child);
      // @ts-ignore
      if (key !== children.length) {
        childrenWithGaps.push(<Gap key={'gap' + key++} size={gap} height={gap}/>);
      }
    });

    children = childrenWithGaps;
  }

  return (
    <div className={classes} style={styles} {...other}>
      {children}
    </div>
  )
};
